export const filterFormFixture = (optionData, userDetails) => {
  return [
    {
      inputProps: {
        type: "select",
        className: "form-control",
        placeholder: "Select",
        name: "centerId",
      },
      parentClassName: "row mb-3",
      className: "col-12",
      options: optionData?.centerNames ? [...optionData.centerNames] : [],
      optionProps: { textKey: "name", valueKey: "id" },
      label: {
        text: "Center Name",
        labelProps: { htmlFor: "centerId", className: "" },
      },
      row: "new",
      readOnlyField: userDetails?.centerId === 1 ? false : true,
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "from_date",
      },
      className: "col-12",
      label: {
        text: "From",
        labelProps: { htmlFor: "from_date", className: "" },
      },
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "to_date",
      },
      className: "col-12",
      label: {
        text: "To",
        labelProps: { htmlFor: "to_date", className: "" },
      },
    },
  ];
};

export const filterInputFixture = (data) => ({
  centerId: data?.centerId || "",
  from_date: "",
  to_date: "",
});

export const singleReportHeaderFixture = [
  { text: "S No.", key: "serial_num" },
  { text: "Name", key: "name" },
  { text: "Unique Id", key: "uniqueId" },
  { text: "Center Unique Id", key: "unique_centerId" },
  { text: "Status", key: "history_status", formatVal: true },
  { text: "Aadhar No.", key: "aadharno" },
  { text: "CWC Case No.", key: "cwccaseno" },
  { text: "Gender", key: "gender" },
  { text: "Center Name", objKey: "center_data", key: "name" },
  { text: "Date Of Arrival", key: "dateofarrival" },
  { text: "Created Date Time", key: "created_at", formatDate: true },
  { text: "Modified Date-Time", key: "updated_at", formatDate: true },
];

export const singleGroupReportHeaderFixture = [
  { text: "S No.", key: "serial_num" },
  { text: "Name", key: "name" },
  { text: "Unique Id", key: "uniqueId" },
  { text: "Aadhar No.", key: "aadharno" },
  { text: "Status", key: "history_status", formatVal: true },
  { text: "CWC Case No.", key: "cwccaseno" },
  { text: "Gender", key: "gender" },
  { text: "Center Name", key: "center_name" },
  { text: "Date Of Arrival", key: "dateofarrival" },
  { text: "Created Date Time", key: "created_at", formatDate: true },
  { text: "Modified Date-Time", key: "updated_at", formatDate: true },
];

export const previousBalanceTableHFixture = [
  { text: "S No.", key: "serial_num" },
  { text: "User Name", objkey: "user_data", key: "name" },
  { text: "Center Name", objkey: "center_data", key: "name" },
  { text: "Activity Data", key: "activity_date" },
  { text: "Comment", key: "comment" },
  { text: "Male Count", key: "male" },
  { text: "Female Count", key: "female" },
  {
    text: "Total Balance",
    key: "total_balance",
    fn: (rowData) => <span>{rowData?.total_balance}</span>,
  },
  { text: "Action", action: true, key: ["edit"] },
];

export const balanceDetailsFixture = (data) => ({
  centerId: data?.centerId || "",
  activity_date: "",
  comment: "",
  male: 0,
  female: 0,
});

export const balanceFilterFixture = (data) => ({
  centerId: data?.centerId || "",
  activity_date: "",
  from_date: "",
  to_date: "",
});

export const balanceFilterFormFixture = (optionData, userDetails) => {
  return [
    {
      inputProps: {
        type: "select",
        className: "form-control",
        placeholder: "Select",
        name: "centerId",
      },
      parentClassName: "row mb-3",
      className: "col-12",
      options: optionData?.centerNames ? [...optionData.centerNames] : [],
      optionProps: { textKey: "name", valueKey: "id" },
      label: {
        text: "Center Name",
        labelProps: { htmlFor: "centerId", className: "" },
      },
      row: "new",
      readOnlyField: userDetails?.centerId === 1 ? false : true,
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "activity_date",
      },
      className: "col-12",
      label: {
        text: "Activity Date",
        labelProps: { htmlFor: "activity_date", className: "" },
      },
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "from_date",
      },
      className: "col-12",
      label: {
        text: "From",
        labelProps: { htmlFor: "from_date", className: "" },
      },
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "to_date",
      },
      className: "col-12",
      label: {
        text: "To",
        labelProps: { htmlFor: "to_date", className: "" },
      },
    },
  ];
};

export const balanceDetailsFormFixture = (optionData, userDetails) => {
  return [
    {
      inputProps: {
        type: "select",
        className: "form-control",
        placeholder: "Select",
        name: "centerId",
      },
      parentClassName: "row mb-3",
      className: "col-12 col-md-6",
      options: optionData?.centerNames ? [...optionData.centerNames] : [],
      optionProps: { textKey: "name", valueKey: "id" },
      label: {
        text: "Center Name",
        labelProps: { htmlFor: "centerId", className: "" },
      },
      row: "new",
      readOnlyField: userDetails?.centerId === 1 ? false : true,
      required: true,
    },
    {
      inputProps: {
        type: "text",
        isdatefield: true,
        className: "form-control border-right-0",
        placeholder: "DD-MM-YY",
        name: "activity_date",
      },
      className: "col-12 col-md-6",
      label: {
        text: "Activity Date",
        labelProps: { htmlFor: "activity_date", className: "" },
      },
      required: true,
    },
    {
      inputProps: {
        type: "number",
        className: "form-control",
        placeholder: "Write here ...",
        name: "male",
      },
      className: "col-12 col-md-6",
      parentProps: { input: { className: "form-group mb-4" } },
      label: {
        text: "Male",
        labelProps: { htmlFor: "female", className: "" },
      },
    },
    {
      inputProps: {
        type: "number",
        className: "form-control",
        placeholder: "Write here ...",
        name: "female",
      },
      className: "col-12 col-md-6",
      parentProps: { input: { className: "form-group mb-4" } },
      label: {
        text: "Female",
        labelProps: { htmlFor: "female", className: "" },
      },
    },
    {
      inputProps: {
        type: "textarea",
        className: "form-control",
        placeholder: "Write here ...",
        name: "comment",
      },
      className: "col-12",
      parentProps: { input: { className: "form-group mb-4" } },
      label: {
        text: "Comments",
        labelProps: { htmlFor: "comment", className: "" },
      },
      required: true,
    },
  ];
};
